import { callApi } from './api';

class TrackingService {
  async getUrl() {
    return await callApi({ url: '/api/tracking/pixel/' });
  }
}

export const trackingService = new TrackingService();
